import { createQueryKeys } from '@lukemorales/query-key-factory';
import axios from 'axios';
import { type MaybeRef, unref } from 'vue';

export const polisQueries = createQueryKeys('polissen', {
  getDetails: (polisnummer: MaybeRef<string>) => ({
    queryKey: [polisnummer],
    queryFn: () =>
      axios.get(`/net/relation/Getpolisdetails`, {
        params: { polisnummer: unref(polisnummer) },
      }),
  }),
  getGebouwomschrijving: (code: MaybeRef<string>) => ({
    queryKey: [code],
    queryFn: () =>
      axios.get(`/net/relation/GetGebouwOms`, {
        params: { code: unref(code) },
      }),
  }),
  getClausule: (clausulenummer: MaybeRef<number>, polisnummer: MaybeRef<string>) => ({
    queryKey: [clausulenummer, polisnummer],
    queryFn: () =>
      axios.get(`/content/ajax/GetClausuleTekst`, {
        params: {
          unieknummer: unref(clausulenummer),
          polisnummer: unref(polisnummer),
        },
      }),
  }),
  getRoydata: (polisnummer: MaybeRef<string>) => ({
    queryKey: [polisnummer],
    queryFn: () =>
      axios.get(`/net/relation/GetRoyData`, {
        params: { polisnummer: unref(polisnummer) },
      }),
  }),
});
